import { computed } from "vue";
import { usePreferencesStore } from "@/stores/preferences";
import { localizedDate, localizedError, translate, type MessageParams } from "./runtime";

export { translate } from "./runtime";
export function useI18n() {
  const preferences = usePreferencesStore();
  const locale = computed(() => preferences.locale);
  return {
    locale,
    t: (source: string, params?: MessageParams) => translate(source, params, locale.value),
    formatNumber: (value: number, options?: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale.value, options).format(value),
    formatDate: (value: string | number | Date | null | undefined, options?: Intl.DateTimeFormatOptions) => localizedDate(value, options, locale.value),
    errorMessage: (cause: unknown, fallback: string) => localizedError(cause, fallback, locale.value),
  };
}
